import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import loadable from '@loadable/component';
import classNames from 'classnames';

import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { FiShield, FiChevronRight } from 'react-icons/fi';
import { isConsignmentListing } from '../TimestampBadge/TimestampBadge';
import {
  displayDeliveryPickup,
  displayDeliveryShipping,
  displayPrice,
} from '../../util/configHelpers';
import {
  propTypes,
  AVAILABILITY_MULTIPLE_SEATS,
  LISTING_STATE_CLOSED,
  LINE_ITEM_NIGHT,
  LINE_ITEM_DAY,
  LINE_ITEM_HOUR,
  LINE_ITEM_FIXED,
  LINE_ITEM_ITEM,
  STOCK_MULTIPLE_ITEMS,
  STOCK_INFINITE_MULTIPLE_ITEMS,
  LISTING_STATE_PUBLISHED,
} from '../../util/types';
import { formatMoney } from '../../util/currency';
import { createSlug, parse, stringify } from '../../util/urlHelpers';
import { userDisplayNameAsString } from '../../util/data';
import {
  INQUIRY_PROCESS_NAME,
  getSupportedProcessesInfo,
  isBookingProcess,
  isPurchaseProcess,
  resolveLatestProcessName,
} from '../../transactions/transaction';

import { H2, InlineTextButton, NamedLink } from '..';
import PriceVariantPicker from '../OrderPanel/PriceVariantPicker/PriceVariantPicker';

import newCss from './customorderpannel.module.css';
import { types as sdkTypes } from '../../util/sdkLoader';
// import share from '../../assets/Share.png';
import star from '../../assets/Star.png';
import SectionAuthorMaybe from '../../containers/ListingPage/SectionAuthorMaybe';
// import payment from '../../assets/Clip path group.png';
import buyerProtection from '../../assets/svg/buyer-protection.svg';
import delivary from '../../assets/Vector.png';
import returnPic from '../../assets/Vector (1).png';
// import cross from '../../assets/cross.png';
import outlook from '../../assets/Microsoft_Outlook_new_logo.svg 1.png';
import micro365 from '../../assets/microsoft_365_copilot-logo_brandlogos.net_h3z8h-300x300 1.png';
import whatsApp from '../../assets/WhatsApp.svg 1.png';
import mail from '../../assets/7611776 1.png';
import copilot from '../../assets/Copilot-Logo 1.png';
import faceBook from '../../assets/2023_Facebook_icon.svg 1.png';
import Xlogo from '../../assets/X_logo_2023_original 1.png';
import linkedIn from '../../assets/LinkedIn_icon.svg 1.png';
import copyLink from '../../assets/iconoir_copy.png';
import shareByLocation from '../../assets/Share copy.png';
import sharearrow from '../../assets/sharearrow.png';
import { apiBaseUrl } from '../../util/api';
import axios from 'axios';
import { trackAddToCart } from '../../util/metaPixel';
import { useConfiguration } from '../../context/configurationContext';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import ShareButton from '../Share/Share';
import { withDimensions, withViewport } from '../../util/uiHelpers';
import { createResourceLocatorString } from '../../util/routes';
import { MAX_CART_ITEM } from '../../config/configDefault';
import { updateSearchPageWindowFlag } from '../../containers/SearchPage/helper';

import { ReactComponent as BrandIcon } from '../../assets/svg/Brand.svg';
import { ReactComponent as SizeIcon } from '../../assets/svg/Size.svg';
import { ReactComponent as ColorIcon } from '../../assets/svg/Color.svg';
import { ReactComponent as CondtionIcon } from '../../assets/svg/Condition.svg';
import { ReactComponent as ReturnIconNew } from '../../assets/svg/return-icon.svg';
import { ReactComponent as DeliveryIconNew } from '../../assets/svg/delivery-icon.svg';
import { ReactComponent as BuyerProtectionIconNew } from '../../assets/svg/buyer-protection-icon.svg';

const BookingTimeForm = loadable(() =>
  import(/* webpackChunkName: "BookingTimeForm" */ '../OrderPanel/BookingTimeForm/BookingTimeForm')
);
const BookingDatesForm = loadable(() =>
  import(
    /* webpackChunkName: "BookingDatesForm" */ '../OrderPanel/BookingDatesForm/BookingDatesForm'
  )
);
const BookingFixedDurationForm = loadable(() =>
  import(
    /* webpackChunkName: "BookingFixedDurationForm" */ '../OrderPanel/BookingFixedDurationForm/BookingFixedDurationForm'
  )
);
const InquiryWithoutPaymentForm = loadable(() =>
  import(
    /* webpackChunkName: "InquiryWithoutPaymentForm" */ '../OrderPanel/InquiryWithoutPaymentForm/InquiryWithoutPaymentForm'
  )
);
const ProductOrderForm = loadable(() =>
  import(
    /* webpackChunkName: "ProductOrderForm" */ '../OrderPanel/ProductOrderForm/ProductOrderForm'
  )
);

// This defines when ModalInMobile shows content as Modal
const MODAL_BREAKPOINT = 1023;
const TODAY = new Date();
const MOBILE_BREAKPOINT = 576;

const isPublishedListing = listing => {
  return listing.attributes.state === LISTING_STATE_PUBLISHED;
};

const priceData = (price, currency, intl) => {
  if (price && price.currency === currency) {
    const formattedPrice = formatMoney(intl, price);
    return { formattedPrice, priceTitle: formattedPrice };
  } else if (price) {
    return {
      formattedPrice: `(${price.currency})`,
      priceTitle: `Unsupported currency (${price.currency})`,
    };
  }
  return {};
};

const getCheapestPriceVariant = (priceVariants = []) => {
  return priceVariants.reduce((cheapest, current) => {
    return current.priceInSubunits < cheapest.priceInSubunits ? current : cheapest;
  }, priceVariants[0]);
};

const formatMoneyIfSupportedCurrency = (price, intl) => {
  try {
    return formatMoney(intl, price);
  } catch (e) {
    return `(${price.currency})`;
  }
};

const openOrderModal = (isOwnListing, isClosed, history, location) => {
  if (isOwnListing || isClosed) {
    window.scrollTo(0, 0);
  } else {
    const { pathname, search, state } = location;
    const searchString = `?${stringify({ ...parse(search), orderOpen: true })}`;
    history.push(`${pathname}${searchString}`, state);
  }
};

const closeOrderModal = (history, location) => {
  const { pathname, search, state } = location;
  const { orderOpen, ...searchParams } = parse(search);
  const searchString = `?${stringify(searchParams)}`;
  history.push(`${pathname}${searchString}`, state);
};

const handleSubmit = (
  isOwnListing,
  isClosed,
  isInquiryWithoutPayment,
  onSubmit,
  history,
  location
) => {
  // TODO: currently, inquiry-process does not have any form to ask more order data.
  // We can submit without opening any inquiry/order modal.
  return isInquiryWithoutPayment
    ? () => onSubmit({})
    : () => openOrderModal(isOwnListing, isClosed, history, location);
};

const dateFormattingOptions = { month: 'short', day: 'numeric', weekday: 'short' };

const PriceMaybe = props => {
  const {
    price,
    publicData,
    validListingTypes,
    intl,
    marketplaceCurrency,
    showCurrencyMismatch = false,
  } = props;
  const { listingType, unitType } = publicData || {};

  const foundListingTypeConfig = validListingTypes.find(conf => conf.listingType === listingType);
  const showPrice = displayPrice(foundListingTypeConfig);
  const isPriceVariationsInUse = !!publicData?.priceVariationsEnabled;
  const hasMultiplePriceVariants = publicData?.priceVariants?.length > 1;

  if (!showPrice || !price || (isPriceVariationsInUse && hasMultiplePriceVariants)) {
    return null;
  }

  // Get ratingCount price or currency code if the currency does not match with marketplace currency
  const { formattedPrice, priceTitle } = priceData(price, marketplaceCurrency, intl);
  const priceValue = (
    <span className={newCss.priceValue}>{formatMoneyIfSupportedCurrency(price, intl)}</span>
  );
  const pricePerUnit = (
    <span className={newCss.perUnit}>
      <FormattedMessage id="OrderPanel.perUnit" values={{ unitType }} />
    </span>
  );

  // TODO: In CTA, we don't have space to show proper error message for a mismatch of marketplace currency
  //       Instead, we show the currency code in place of the price
  return showCurrencyMismatch ? (
    <div className={newCss.priceContainerInCTA}>
      <div className={newCss.priceValueInCTA} title={priceTitle}>
        <FormattedMessage
          id="OrderPanel.priceInMobileCTA"
          values={{ priceValue: formattedPrice }}
        />
      </div>
      <div className={newCss.perUnitInCTA}>
        <FormattedMessage id="OrderPanel.perUnit" values={{ unitType }} />
      </div>
    </div>
  ) : (
    <div className={newCss.priceContainer}>
      <p className={newCss.price}>
        <FormattedMessage id="OrderPanel.price" values={{ priceValue, pricePerUnit }} />
      </p>
    </div>
  );
};

const PriceMissing = () => {
  return (
    <p className={newCss.error}>
      <FormattedMessage id="OrderPanel.listingPriceMissing" />
    </p>
  );
};
const InvalidCurrency = () => {
  return (
    <p className={newCss.error}>
      <FormattedMessage id="OrderPanel.listingCurrencyInvalid" />
    </p>
  );
};

const InvalidPriceVariants = () => {
  return (
    <p className={newCss.error}>
      <FormattedMessage id="OrderPanel.listingPriceVariantsAreInvalid" />
    </p>
  );
};

const hasUniqueVariants = priceVariants => {
  const priceVariantsSlugs = priceVariants?.map(variant =>
    variant.name ? createSlug(variant.name) : 'no-name'
  );
  return new Set(priceVariantsSlugs).size === priceVariants.length;
};

const hasValidPriceVariants = priceVariants => {
  const isArray = Array.isArray(priceVariants);
  const hasItems = isArray && priceVariants.length > 0;
  const variantsHaveNames = hasItems && priceVariants.every(variant => variant.name);
  const namesAreUnique = hasItems && hasUniqueVariants(priceVariants);

  return variantsHaveNames && namesAreUnique;
};

function MultiLineEllipsisText(props) {
  const [showFullContent, setShowFullContent] = useState(false);
  const [enableShowMore, setEnableShowMore] = useState(false);
  const { text, viewport, isHtmlText, noOfLines = 3 } = props;
  const { width } = viewport;
  const htmlText = isHtmlText ? text.replaceAll('＜', '<').replaceAll('＞', '>') : text;
  const lineHeight = width <= MOBILE_BREAKPOINT ? 24 : 36;
  const maxContentHeight = noOfLines * lineHeight + 16;
  const style =
    width <= MOBILE_BREAKPOINT
      ? { fontSize: '18px', lineHeight: `${lineHeight}px` }
      : { fontSize: '24px', lineHeight: `${lineHeight}px` };

  const pRefCallback = el => {
    if (!el) {
      return;
    }
    const textHeight = el.clientHeight;
    setEnableShowMore(textHeight > maxContentHeight);
  };
  const toggleFullContent = () => {
    setShowFullContent(fullContent => !fullContent);
  };

  return (
    <React.Fragment>
      <div
        className={newCss.multiLineEllipsis}
        style={{ maxHeight: showFullContent ? 'unset' : `${maxContentHeight}px` }}
      >
        {isHtmlText ? (
          <p dangerouslySetInnerHTML={{ __html: htmlText }} style={style} ref={pRefCallback} />
        ) : (
          <p style={style} ref={pRefCallback}>
            {htmlText}
          </p>
        )}
        {showFullContent ? null : enableShowMore ? (
          <span className={newCss.overlay} style={{ height: `${lineHeight}px` }} />
        ) : null}
      </div>
      {enableShowMore ? (
        <InlineTextButton onClick={toggleFullContent} className={newCss.seeMoreBtn}>
          {showFullContent ? 'Read Less' : 'See More'}
        </InlineTextButton>
      ) : null}
    </React.Fragment>
  );
}

const WithDimensionMultiLineEllipsisText = withViewport(MultiLineEllipsisText);

/**
 * @typedef {Object} ListingTypeConfig
 * @property {string} listingType - The type of the listing
 * @property {string} transactionType - The type of the transaction
 * @property {string} transactionType.process - The process descriptionof the transaction
 * @property {string} transactionType.alias - The alias of the transaction process
 * @property {string} transactionType.unitType - The unit type of the transaction
 */

/**
 * OrderPanel is a component that renders a panel for making bookings, purchases, or inquiries for a listing.
 * It handles different transaction processes and displays appropriate forms based on the listing type.
 *
 * @param {Object} props
 * @param {string} [props.rootClassName] - Custom class that overwrites the default class for the root element
 * @param {string} [props.className] - Custom class that extends
 * @param {string} [props.titleClassName] - Custom class name for the title
 * @param {propTypes.listing} props.listing - The listing data (either regular or own listing)
 * @param {Array<ListingTypeConfig>} props.validListingTypes - Array of valid listing type configurations
 * @param {boolean} [props.isOwnListing=false] - Whether the listing belongs to the current user
 * @param {listingType.user|listingType.currentUser} props.author - The listing author's user data
 * @param {ReactNode} [props.authorLink] - Custom component for rendering the author link
 * @param {ReactNode} [props.payoutDetailsWarning] - Warning message about payout details
 * @param {Function} props.onSubmit - Handler for form submission
 * @param {ReactNode|string} props.title - Title of the panel
 * @param {ReactNode} [props.titleDesktop] - Alternative title for desktop view
 * @param {ReactNode|string} [props.subTitle] - Subtitle text
 * @param {Function} props.onManageDisableScrolling - Handler for managing scroll behavior
 * @param {Function} props.onFetchTimeSlots - Handler for fetching available time slots
 * @param {Object} [props.monthlyTimeSlots] - Available time slots by month
 * @param {Function} props.onFetchTransactionLineItems - Handler for fetching transaction line items
 * @param {Function} [props.onContactUser] - Handler for contacting the listing author
 * @param {Array} [props.lineItems] - Array of line items for the transaction
 * @param {boolean} props.fetchLineItemsInProgress - Whether line items are being fetched
 * @param {Object} [props.fetchLineItemsError] - Error object if line items fetch failed
 * @param {string} props.marketplaceCurrency - The currency used in the marketplace
 * @param {number} props.dayCountAvailableForBooking - Number of days available for booking
 * @param {string} props.marketplaceName - Name of the marketplace
 *
 * @returns {JSX.Element} Component that displays the order panel with appropriate form
 */
const extractComparePrice = (rawComparePrice, currency, intl) => {
  if (!rawComparePrice) return null;

  try {
    if (typeof rawComparePrice === 'object' && rawComparePrice.amount && rawComparePrice.currency) {
      if (rawComparePrice.currency !== currency) {
        return {
          ratingCount: `(${rawComparePrice.currency})`,
          title: `Unsupported currency (${rawComparePrice.currency})`,
        };
      }

      return {
        ratingCount: formatMoney(intl, rawComparePrice),
        title: formatMoney(intl, rawComparePrice),
      };
    }
    const numericValue =
      typeof rawComparePrice === 'string'
        ? parseFloat(rawComparePrice)
        : typeof rawComparePrice === 'number'
          ? rawComparePrice
          : NaN;

    if (!isNaN(numericValue)) {
      return {
        ratingCount: formatMoney(intl, { amount: Math.round(numericValue * 100), currency }),
        title: formatMoney(intl, { amount: Math.round(numericValue * 100), currency }),
      };
    }
  } catch (e) {
    console.error('Compare price formatting failed:', e);
  }

  return null;
};

const { Money } = sdkTypes;

export function normalizeSize(sizeString) {
  if (!sizeString) return '';
  let cleaned = String(sizeString).trim();
  cleaned = cleaned.replace(/[_\-x*|]+/g, '/');
  const parts = cleaned.split('/');
  if (parts.length === 2 && parts[0].length <= 2) {
    return `${parts[0]}/${parts[1]}`;
  }
  const longMatch = cleaned.replace(/\//g, '').match(/^(\d{2})(\d{2})(\d)(.*)$/);
  if (longMatch) {
    const [, first, second, third, rest] = longMatch;
    return `${first}/${second}/${third}${rest}`;
  }
  return cleaned;
}

export const getListingProperties = (listing, config = {}) => {
  const publicData = listing?.attributes?.publicData || {};
  const { brand, color, condition, categoryLevel1, categoryLevel2 } = publicData;

  const size =
    categoryLevel2 === 'Women-Accessories' || categoryLevel2 === 'men-accessories'
      ? publicData?.Women_Men_Accessories_size
      : categoryLevel2 === 'men-shoes'
        ? publicData?.Mens_Shoes_Sizes
        : categoryLevel2 === 'women-shoes'
          ? publicData?.Womens_Shoes_Sizes
          : publicData?.women_size || publicData?.men_sizes;

  return [
    {
      type: 'brand',
      value: brand,
      customRef: config.customBrandRef,
      link: `/s?pub_brand=${brand}`,
    },
    {
      type: 'size',
      value: size && normalizeSize(size),
      link:
        categoryLevel2 === 'Women-Accessories' || categoryLevel2 === 'men-accessories'
          ? `/s?pub_categoryLevel1=${categoryLevel1}&pub_categoryLevel2=${categoryLevel2}&pub_Women_Men_Accessories_size=${size}`
          : categoryLevel2 === 'men-shoes'
            ? `/s?pub_Mens_Shoes_Sizes=${size}&pub_categoryLevel1=${categoryLevel1}&pub_categoryLevel2=${categoryLevel2}`
            : categoryLevel2 === 'women-shoes'
              ? `/s?pub_Womens_Shoes_Sizes=${size}&pub_categoryLevel1=${categoryLevel1}&pub_categoryLevel2=${categoryLevel2}`
              : categoryLevel2 === 'men_sizes'
                ? `/s?pub_categoryLevel1=${categoryLevel1}&pub_${categoryLevel1}_sizes=${size}`
                : `/s?pub_categoryLevel1=${categoryLevel1}&pub_${categoryLevel1}_size=${size}`,
    },
    {
      type: 'condition',
      value: condition ? condition.replace(/-/g, ' ') : '',
      link: `/s?pub_condition=${condition}`,
    },
    {
      type: 'color',
      value: color,
      link: `/s?pub_color=${color}`,
    },
  ];
};

export const DetailsPillsSection = ({ propertise, className }) => {
  if (!propertise || propertise.length === 0) return null;
  const filtered = propertise.filter(item => item.value && String(item.value).trim() !== '');
  if (filtered.length === 0) return null;

  const renderIcon = type => {
    switch (type) {
      case 'brand':
        return (
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#111111"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
            <line x1="7" y1="7" x2="7.01" y2="7"></line>
          </svg>
        );
      case 'size':
        return (
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#111111"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="9" y1="3" x2="9" y2="21"></line>
            <line x1="3" y1="9" x2="9" y2="9"></line>
            <line x1="3" y1="15" x2="9" y2="15"></line>
          </svg>
        );
      case 'condition':
        return (
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#111111"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
          </svg>
        );
      case 'color':
        return (
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#111111"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"></path>
          </svg>
        );
      default:
        return (
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#111111"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
            <line x1="7" y1="7" x2="7.01" y2="7"></line>
          </svg>
        );
    }
  };

  return (
    <div className={classNames(newCss.detailsSection, className)}>
      <h3 className={newCss.detailsTitle}>
        <FormattedMessage id="CustomOrderPanel.detailsTitle" defaultMessage="DETAILS" />
      </h3>
      <div className={newCss.detailsPills}>
        {filtered.map((item, i) => {
          const { type, value, customRef, link } = item;
          const rawStr = typeof value === 'string' ? customRef?.[value]?.label ?? value : value;
          const displayVal =
            typeof rawStr === 'string' ? rawStr.charAt(0).toUpperCase() + rawStr.slice(1) : rawStr;

          return (
            <Link key={i} to={link} className={newCss.detailPill}>
              {renderIcon(type)}
              <span>{displayVal}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export const DescriptionSection = ({ description, className }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [hasOverflow, setHasOverflow] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      setHasOverflow(textRef.current.scrollHeight > 50);
    }
  }, [description]);

  if (!description) return null;

  const htmlText =
    typeof description === 'string'
      ? description.replaceAll('＜', '<').replaceAll('＞', '>')
      : description;

  return (
    <div className={classNames(newCss.descriptionSectionWrapper, className)}>
      <h3 className={newCss.descriptionLabel}>
        <FormattedMessage id="OrderPanel.descriptionLabel" defaultMessage="WHAT YOU SHOULD KNOW" />
      </h3>
      <div
        ref={textRef}
        className={classNames(newCss.descriptionText, {
          [newCss.descriptionTextCollapsed]: !isExpanded && hasOverflow,
        })}
        dangerouslySetInnerHTML={{ __html: htmlText }}
      />
      {hasOverflow && (
        <button
          type="button"
          className={newCss.seeMoreBtn}
          onClick={() => setIsExpanded(prev => !prev)}
        >
          {isExpanded ? 'See Less' : 'See More'}
        </button>
      )}
    </div>
  );
};

const CustomOrderPannel = props => {
  const {
    rootClassName,
    className,
    titleClassName,
    listing,
    validListingTypes,
    lineItemUnitType: lineItemUnitTypeMaybe,
    isOwnListing,
    onSubmit,
    title,
    titleDesktop,
    author,
    authorLink,
    onManageDisableScrolling,
    onFetchTimeSlots,
    monthlyTimeSlots,
    timeSlotsForDate,
    onFetchTransactionLineItems,
    onContactUser,
    lineItems,
    marketplaceCurrency,
    dayCountAvailableForBooking,
    marketplaceName,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    payoutDetailsWarning,
    onCloseInquiryModal,
    isInquiryModalOpen,
    sendInquiryError,
    sendInquiryInProgress,
    onSubmitInquiry,
    currentUser,
    newTitle,
    pageType,
    onAddOneUserCartCount,
    currentUserCartCount,
    routeConfiguration,
  } = props;
  const [mounted, setMounted] = useState(false);
  // const [readMore, setReadMore] = useState(false);
  // const [shareModal, setShareModal] = useState(false);
  const [selectedStock, setSelectedStock] = useState(1);
  const [isCopied, setIsCopied] = useState(false);
  // const [isCart, setIscart] = useState(listing?.attributes?.publicData?.isAddedToCart || false);
  const [isCart, setIscart] = useState(false);
  const intl = useIntl();
  const location = useLocation();
  const history = useHistory();
  const config = useConfiguration();
  // const enableMulticart = currentUser?.attributes?.profile?.publicData?.multicart;
  const enableMulticart = false;

  useEffect(() => {
    setMounted(true);
  }, []);

  const publicData = listing?.attributes?.publicData || {};
  const { listingType, unitType, transactionProcessAlias = '', priceVariants, startTimeInterval } =
    publicData || {};

  const { rating, featured, ratingCount } = listing?.author?.attributes?.profile?.metadata || {};

  const processName = resolveLatestProcessName(transactionProcessAlias.split('/')[0]);
  const lineItemUnitType = lineItemUnitTypeMaybe || `line-item/${unitType}`;

  const price = listing?.attributes?.price;
  const isPaymentProcess = processName !== INQUIRY_PROCESS_NAME;
  const formattedComparePriceNew = new Money(
    typeof publicData.comparePrice === 'object' ? publicData.comparePrice.amount : null,
    marketplaceCurrency
  );

  const comparePriceData = extractComparePrice(formattedComparePriceNew, marketplaceCurrency, intl);
  const listingDescription = listing?.attributes?.description;

  const showPriceMissing = isPaymentProcess && !price;
  const showInvalidCurrency = isPaymentProcess && price?.currency !== marketplaceCurrency;

  const timeZone = listing?.attributes?.availabilityPlan?.timezone;
  const isClosed = listing?.attributes?.state === LISTING_STATE_CLOSED;

  const isBooking = isBookingProcess(processName);
  const shouldHaveFixedBookingDuration = isBooking && [LINE_ITEM_FIXED].includes(lineItemUnitType);
  const showBookingFixedDurationForm =
    mounted && shouldHaveFixedBookingDuration && !isClosed && timeZone && priceVariants?.length > 0;

  const shouldHaveBookingTime = isBooking && [LINE_ITEM_HOUR].includes(lineItemUnitType);
  const showBookingTimeForm = mounted && shouldHaveBookingTime && !isClosed && timeZone;

  const shouldHaveBookingDates =
    isBooking && [LINE_ITEM_DAY, LINE_ITEM_NIGHT].includes(lineItemUnitType);
  const showBookingDatesForm = mounted && shouldHaveBookingDates && !isClosed && timeZone;

  // The listing resource has a relationship: `currentStock`,
  // which you should include when making API calls.
  const isPurchase = isPurchaseProcess(processName);
  const shouldHavePurchase = isPurchase && lineItemUnitType === LINE_ITEM_ITEM;
  const currentStock = listing.currentStock?.attributes?.quantity;
  const MAX_QUANTITY_FOR_DROPDOWN = 100;
  const selectableStock =
    currentStock > MAX_QUANTITY_FOR_DROPDOWN ? MAX_QUANTITY_FOR_DROPDOWN : currentStock;
  const hasStock = currentStock && currentStock > 0;
  const quantities = hasStock ? [...Array(selectableStock).keys()].map(i => i + 1) : [];
  const isOutOfStock = shouldHavePurchase && !isClosed && currentStock === 0;

  // Show form only when stock is fully loaded. This avoids "Out of stock" UI by
  // default before all data has been downloaded.
  const showProductOrderForm =
    mounted && shouldHavePurchase && !isClosed && typeof currentStock === 'number';

  const showInquiryForm = mounted && !isClosed && processName === INQUIRY_PROCESS_NAME;

  const supportedProcessesInfo = getSupportedProcessesInfo();
  const isKnownProcess = supportedProcessesInfo.map(info => info.name).includes(processName);

  const { pickupEnabled, shippingEnabled, shippingType } = listing?.attributes?.publicData || {};

  const listingTypeConfig = validListingTypes.find(conf => conf.listingType === listingType);
  const displayShipping = displayDeliveryShipping(listingTypeConfig);
  const displayPickup = displayDeliveryPickup(listingTypeConfig);
  const allowOrdersOfMultipleItems = [STOCK_MULTIPLE_ITEMS, STOCK_INFINITE_MULTIPLE_ITEMS].includes(
    listingTypeConfig?.stockType
  );

  const searchParams = parse(location.search);
  const isOrderOpen = !!searchParams.orderOpen;
  const preselectedPriceVariantSlug = searchParams.bookableOption;

  const seatsEnabled = [AVAILABILITY_MULTIPLE_SEATS].includes(listingTypeConfig?.availabilityType);

  // Note: publicData contains priceVariationsEnabled if listing is created with priceVariations enabled.
  const isPriceVariationsInUse = !!publicData?.priceVariationsEnabled;
  const preselectedPriceVariant =
    Array.isArray(priceVariants) && preselectedPriceVariantSlug && isPriceVariationsInUse
      ? priceVariants.find(pv => pv?.name && createSlug(pv?.name) === preselectedPriceVariantSlug)
      : null;

  const priceVariantsMaybe = isPriceVariationsInUse
    ? {
      isPriceVariationsInUse,
      priceVariants,
      priceVariantFieldComponent: PriceVariantPicker,
      preselectedPriceVariant,
      isPublishedListing: isPublishedListing(listing),
    }
    : !isPriceVariationsInUse && showBookingFixedDurationForm
      ? {
        isPriceVariationsInUse: false,
        priceVariants: [getCheapestPriceVariant(priceVariants)],
        priceVariantFieldComponent: PriceVariantPicker,
      }
      : {};

  const showInvalidPriceVariantsMessage =
    isPriceVariationsInUse && !hasValidPriceVariants(priceVariants);

  const sharedProps = {
    lineItemUnitType,
    onSubmit,
    price,
    marketplaceCurrency,
    listingId: listing.id,
    isOwnListing,
    marketplaceName,
    onFetchTransactionLineItems,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    payoutDetailsWarning,
    isListingLoaded: !!listing?.attributes?.description,
  };

  const showClosedListingHelpText = listing.id && isClosed;

  const subTitleText = showClosedListingHelpText
    ? intl.formatMessage({ id: 'OrderPanel.subTitleClosedListing' })
    : null;

  const authorDisplayName = userDisplayNameAsString(author, '');

  const classes = classNames(rootClassName || newCss.root, className);
  const titleClasses = classNames(titleClassName || newCss.orderTitle);
  const { brand, color, condition, categoryLevel1, categoryLevel2 } = publicData;

  const size =
    categoryLevel2 === 'Women-Accessories' || categoryLevel2 === 'men-accessories'
      ? publicData?.Women_Men_Accessories_size
      : categoryLevel2 === 'men-shoes'
        ? publicData?.Mens_Shoes_Sizes
        : categoryLevel2 === 'women-shoes'
          ? publicData?.Womens_Shoes_Sizes
          : publicData?.women_size || publicData?.men_sizes;

  function normalizeSize(sizeString) {
    let cleaned = sizeString.trim();
    cleaned = cleaned.replace(/[_\-x*|]+/g, '/');
    const parts = cleaned.split('/');
    if (parts.length === 2 && parts[0].length <= 2) {
      return `${parts[0]}/${parts[1]}`;
    }
    const longMatch = cleaned.replace(/\//g, '').match(/^(\d{2})(\d{2})(\d)(.*)$/);
    if (longMatch) {
      const [, first, second, third, rest] = longMatch;
      return `${first}/${second}/${third}${rest}`;
    }

    return cleaned;
  }

  const propertise = [
    {
      type: 'brand',
      value: brand,
      customRef: config.customBrandRef,
      link: `/s?pub_brand=${brand}`,
    },
    {
      type: 'size',
      value: size && normalizeSize(size),
      link:
        categoryLevel2 === 'Women-Accessories' || categoryLevel2 === 'men-accessories'
          ? `/s?pub_categoryLevel1=${categoryLevel1}&pub_categoryLevel2=${categoryLevel2}&pub_Women_Men_Accessories_size=${size}`
          : categoryLevel2 === 'men-shoes'
            ? `/s?pub_Mens_Shoes_Sizes=${size}&pub_categoryLevel1=${categoryLevel1}&pub_categoryLevel2=${categoryLevel2}`
            : categoryLevel2 === 'women-shoes'
              ? `/s?pub_Womens_Shoes_Sizes=${size}&pub_categoryLevel1=${categoryLevel1}&pub_categoryLevel2=${categoryLevel2}`
              : categoryLevel2 === 'men_sizes'
                ? `/s?pub_categoryLevel1=${categoryLevel1}&pub_${categoryLevel1}_sizes=${size}`
                : `/s?pub_categoryLevel1=${categoryLevel1}&pub_${categoryLevel1}_size=${size}`,
    },
    {
      type: 'condition',
      value: condition ? condition.replace(/-/g, ' ') : ' ',
      link: `/s?pub_condition=${condition}`,
    },
    {
      type: 'color',
      value: color,
      link: `/s?pub_color=${color}`,
    },
  ];
  const policies = [
    {
      title: 'Easy returns',
      subtitle: 'Return within 48h',
      icon: <ReturnIconNew />,
    },
    {
      title: 'Delivery via Pudo',
      subtitle: 'From R49 to lockers or door',
      icon: <DeliveryIconNew />,
    },
    {
      title: 'Buyer protection',
      subtitle: 'Shop with peace of mind',
      icon: <BuyerProtectionIconNew />,
    },
  ];

  const PropertyBox = props => {
    const { type, value, customRef, link } = props;

    const valueStr =
      typeof value === 'string'
        ? customRef?.[value]?.label?.toUpperCase() ?? value.charAt(0).toUpperCase() + value.slice(1)
        : value;

    const handleClick = e => {
      e.preventDefault();
      e.stopPropagation();
      updateSearchPageWindowFlag({ preventLoading: false });
      history.push(link);
    };

    return (
      <div className={newCss.propertyBox}>
        <p className={newCss.properType}>{typeof type === 'string' && type.toUpperCase()}</p>

        <Link className={newCss.propervalue} to={link} onClick={handleClick}>
          {valueStr}
        </Link>
        {/* <div className={newCss.propervalue}>{valueStr}</div> */}
      </div>
    );
  };

  const PolicyBar = props => {
    const { title, subtitle, icon } = props;

    return (
      <div className={newCss.policyMain}>
        <div className={newCss.policyImgBox}>{icon}</div>
        <div className={newCss.policyContent}>
          <p className={newCss.policyText}>{title}</p>
          <p className={newCss.policySubtitle}>{subtitle}</p>
        </div>
      </div>
    );
  };

  const ReviewBlock = props => {
    let { rating, ratingCount } = props;
    const numRating = Number(rating);
    const isValidRating = !isNaN(numRating) && numRating > 0 && numRating <= 5;
    const displayRating = isValidRating
      ? numRating % 1 === 0
        ? numRating.toString()
        : numRating.toFixed(2)
      : null;

    if (!displayRating || !ratingCount) {
      return null;
    }

    if (ratingCount >= 1000) {
      ratingCount = (ratingCount / 1000).toFixed(1);
      ratingCount = ratingCount.endsWith('.0') ? ratingCount.slice(0, -2) : ratingCount;
      ratingCount += 'k';
    }

    return (
      <div className={newCss.reviewBox}>
        <svg
          className={newCss.starIcon}
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="#fec000"
          stroke="#fec000"
        >
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
        </svg>
        <span className={newCss.ratingValue}>{displayRating}</span>
        <span className={newCss.ratingCount}>({ratingCount || 127})</span>
      </div>
    );
  };

  const shareItems = [
    {
      icon: shareByLocation,
      shareText: 'Nearby Sharing',
    },
    {
      icon: outlook,
      shareText: 'Outlook',
      link:
        'https://www.microsoft.com/en-us/microsoft-365/outlook/email-and-calendar-software-microsoft-outlook?deeplink=%2fmail%2f0%2f%3fnlp%3d0&sdf=0',
    },
    {
      icon: micro365,
      shareText: 'Microsoft 365',
      link: 'https://www.office.com/',
    },
    {
      icon: whatsApp,
      shareText: 'Whatsapp',
      link: 'https://web.whatsapp.com/',
    },
    {
      icon: mail,
      shareText: 'Gmail',
      link: `https://mail.google.com/`,
    },
    {
      icon: copilot,
      shareText: 'Copilot',
      link: 'https://copilot.microsoft.com/chats/uEdqhe9irFzNLdisbSfee',
    },
    {
      icon: faceBook,
      shareText: 'Facebook',
      link: 'https://www.facebook.com/',
    },
    {
      icon: Xlogo,
      shareText: 'X',
      link: 'https://x.com/',
    },
    {
      icon: linkedIn,
      shareText: 'Linkedin',
      link: 'https://in.linkedin.com/',
    },
    {
      icon: copyLink,
      shareText: 'Copy link',
    },
  ];

  const handleCopyClick = async url => {
    try {
      url = 'https://wisi-oi-dev-8e7c267d141d.herokuapp.com' + url;
      setIsCopied(true);
      await navigator.clipboard.writeText(url);
      setTimeout(() => setIsCopied(false), 1500);
    } catch (err) {
      console.error('Failed to copy link: ', err);
    }
  };

  const handelNearByShare = async () => {
    if (!navigator.share) return;
    try {
      await navigator.share({
        title: 'KlosetKlub',
        text: 'Share',
        url: location?.href,
      });
    } catch (error) {
      console.error('Error sharing content:', error);
    }
  };

  const handelCart = qty => async () => {
    // if (!currentUser) return;
    try {
      if (isCart) {
        const url = createResourceLocatorString('CartPage', routeConfiguration, {});
        history.push(url);
        return;
      }
      const isMaxCartItemAdded = currentUserCartCount >= MAX_CART_ITEM;
      if (isMaxCartItemAdded) {
        return;
      }
      await axios.post(
        `${apiBaseUrl()}/api/carts/add`,
        {
          listingId: listing?.id?.uuid,
          qty: qty || 1,
          authorId: listing?.author?.id?.uuid,
        },
        {
          withCredentials: true,
        }
      );
      onAddOneUserCartCount();
      setIscart(true);

      const listingPrice = listing?.attributes?.price;
      const priceValue = listingPrice?.amount ? listingPrice.amount / 100 : 0;
      const quantity = qty || 1;

      // Track add to cart with Google Analytics 4
      if (typeof window !== 'undefined' && window.gtag) {
        try {
          const currency = listingPrice?.currency || 'ZAR';

          window.gtag('event', 'add_to_cart', {
            currency: currency,
            value: priceValue * quantity,
            items: [
              {
                item_id: listing?.id?.uuid,
                item_name: listing?.attributes?.title || 'Product',
                price: priceValue,
                currency: currency,
                quantity: quantity,
              },
            ],
          });
        } catch (error) {
          console.error('Failed to track add_to_cart with Google Analytics:', error);
        }
      }

      // Track add to cart with Meta Pixel
      trackAddToCart(listing, quantity);
    } catch (error) {
      console.log('Something Went Wrong in cart', error);
    }
  };

  const checkAlreadyInCart = async () => {
    const targetListingId = listing?.id?.uuid;
    const targetUserId = currentUser?.id?.uuid;
    if (!targetListingId || !targetUserId) {
      setIscart(false);
      return;
    }
    try {
      const response = await axios.get(`${apiBaseUrl()}/api/carts/all`, {
        withCredentials: true,
        params: { perPage: 20 },
      });

      if (response.status === 200) {
        const inCart = Array.isArray(response.data?.data)
          ? response.data.data.some(
            e =>
              e.listingId === targetListingId &&
              e.userId === targetUserId &&
              e.isSelectedForCheckout
          )
          : false;

        // Only update state if we are still on the same listing/user
        if (targetListingId === listing?.id?.uuid && targetUserId === currentUser?.id?.uuid) {
          setIscart(inCart);
        }
      } else {
        // Non-200 response, ensure state reflects not-in-cart for safety
        setIscart(false);
      }
    } catch (error) {
      console.log(error);
      // On error, default to not-in-cart for current product view
      setIscart(false);
    }
  };

  useEffect(() => {
    const hasIds = currentUser?.id?.uuid && listing?.id?.uuid;
    if (!hasIds) {
      setIscart(false);
      return;
    }

    let canceled = false;
    (async () => {
      if (!canceled) await checkAlreadyInCart();
    })();
    return () => {
      canceled = true;
    };
  }, [listing?.id?.uuid, currentUser?.id?.uuid]);

  return (
    <div className={newCss.container}>
      {isConsignmentListing(listing) && (
        <div className={newCss.trustStrip}>
          <div className={newCss.trustStripLeft}>
            <svg
              className={newCss.trustStripShieldIcon}
              viewBox="0 0 32 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 34C16 34 29 26.5 29 14.5V6L16 2L3 6V14.5C3 26.5 16 34 16 34Z"
                fill="#5E4896"
                stroke="#5E4896"
                strokeWidth="1.5"
                strokeLinejoin="round"
              />
              <path
                d="M11 17L14.5 20.5L21 14"
                stroke="white"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div className={newCss.trustStripContent}>
              <span className={newCss.trustStripTitle}>
                <FormattedMessage id="CustomOrderPanel.checkedByKlosetKlub" />
              </span>
              <span className={newCss.trustStripSubtext}>
                <FormattedMessage id="CustomOrderPanel.managedByOurTeam" />
              </span>
            </div>
          </div>
          {/* <FiChevronRight className={newCss.trustStripArrow} /> */}
        </div>
      )}
      <div className={newCss.main}>
        <div className={classNames(newCss.titleBox, newCss.mobileOnlyTitle)}>
          <div className={newCss.title}>
            {titleDesktop ? titleDesktop : <H2 className={titleClasses}>{title}</H2>}
            {subTitleText ? <div className={newCss.orderHelp}>{subTitleText}</div> : null}
          </div>
        </div>
        <SectionAuthorMaybe
          title={newTitle}
          listing={listing}
          onContactUser={onContactUser}
          isInquiryModalOpen={isInquiryModalOpen}
          onCloseInquiryModal={() => onCloseInquiryModal(false)}
          sendInquiryError={sendInquiryError}
          sendInquiryInProgress={sendInquiryInProgress}
          onSubmitInquiry={onSubmitInquiry}
          currentUser={currentUser}
          onManageDisableScrolling={onManageDisableScrolling}
          authorDisplayName={authorDisplayName}
          authorRating={
            rating > 0 ? <ReviewBlock rating={rating} ratingCount={ratingCount} /> : null
          }
        />
        {/* {featured && (
          <ReviewBlock rating={rating} ratingCount={ratingCount}/>
        )} */}
        {/* <div className={newCss.priceCont}>
          <PriceMaybe
            price={price}
            publicData={publicData}
            validListingTypes={validListingTypes}
            intl={intl}
            marketplaceCurrency={marketplaceCurrency}
            showCurrencyMismatch
          />
        </div> */}

        {/* {currentStock > 1 ? (
          <div className={newCss.selectStockDiv}>
            <label htmlFor={`stock`}>{intl.formatMessage({ id: 'OrderPanel.stockLabel' })}</label>
            <select
              id="stock"
              className={newCss.stockDropdown}
              value={selectedStock} // always control it by value, not selected attr
              onChange={e => setSelectedStock(Number(e.target.value))}
            >
              <option disabled value={0}>
                {intl.formatMessage({ id: 'OrderPanel.stockInputPlaceholder' })}
              </option>
              {quantities.map(quantity => (
                <option key={quantity} value={quantity}>
                  {intl.formatMessage({ id: 'ProductOrderForm.quantityOption' }, { quantity })}
                </option>
              ))}
            </select>
          </div>
        ) : null} */}

        <div className={newCss.mobileOnlySection}>
          <DetailsPillsSection propertise={propertise} />
        </div>

        <div className={newCss.policySection}>
          <div className={newCss.policyContainer}>
            <div className={newCss.policyBox}>
              {policies.map((ele, i) => {
                return <PolicyBar key={i} {...ele} />;
              })}
            </div>
            <p className={newCss.policySubText}>
              *
              <FormattedMessage
                id="CustomOrderPanel.buyerProtectionText"
                defaultMessage="Every order is protected by the Kloset Klub buyer protection."
              />
            </p>
          </div>
        </div>

        <div className={newCss.mobileOnlySection}>
          <DescriptionSection description={listingDescription} />
        </div>
        {isClosed ? (
          <div className={newCss.closedListingButton}>
            <FormattedMessage id="OrderPanel.closedListingButtonText" />
          </div>
        ) : (
          // <div className={newCss.buttonContainer}>
          //   {/* <PrimaryButton
          //     onClick={handleSubmit(
          //       isOwnListing,
          //       isClosed,
          //       showInquiryForm,
          //       onSubmit,
          //       history,
          //       location
          //     )}
          //     disabled={isOutOfStock}
          //   >
          //     {isBooking ? (
          //       <FormattedMessage id="OrderPanel.ctaButtonMessageBooking" />
          //     ) : isOutOfStock ? (
          //       <FormattedMessage id="OrderPanel.ctaButtonMessageNoStock" />
          //     ) : isPurchase ? (
          //       <FormattedMessage id="OrderPanel.ctaButtonMessagePurchase" />
          //     ) : (
          //       <FormattedMessage id="OrderPanel.ctaButtonMessageInquiry" />
          //     )}
          //   </PrimaryButton> */}
          // <button
          //   className={newCss.primaryBtn}
          //   onClick={() =>
          //     handleSubmit(isOwnListing, isClosed, showInquiryForm, onSubmit, history, location)
          //   }
          //   disabled={isOutOfStock}
          // >
          //   {isBooking ? (
          //     <FormattedMessage id="OrderPanel.ctaButtonMessageBooking" />
          //   ) : isOutOfStock ? (
          //     <FormattedMessage id="OrderPanel.ctaButtonMessageNoStock" />
          //   ) : isPurchase ? (
          //     <FormattedMessage id="OrderPanel.ctaButtonMessagePurchase" />
          //   ) : (
          //     <FormattedMessage id="OrderPanel.ctaButtonMessageInquiry" />
          //   )}
          // </button>
          //   <button className={newCss.cartBtn}>
          //     <FormattedMessage id="OrderPanel.addToCartBtnText" />
          //   </button>

          //   <div className={newCss.mobilePriceCont}>
          //     <div className={newCss.priceBox}>
          //       <PriceMaybe
          //         price={price}
          //         publicData={publicData}
          //         validListingTypes={validListingTypes}
          //         intl={intl}
          //         marketplaceCurrency={marketplaceCurrency}
          //         showCurrencyMismatch
          //       />
          //     </div>
          //   </div>
          // </div>
          <div className={newCss.btnBox}>
            {isOwnListing ? (
              <div className={newCss.stickyBottomBar}>
                <div className={newCss.stickyBottomBarWrapper}>
                  <div className={newCss.stickyBottomBarInner}>
                    <div className={newCss.priceSection}>
                      <div className={newCss.productPriceWrapper}>
                        <PriceMaybe
                          price={price}
                          publicData={publicData}
                          validListingTypes={validListingTypes}
                          intl={intl}
                          marketplaceCurrency={marketplaceCurrency}
                          showCurrencyMismatch
                        />
                      </div>
                      <div className={newCss.priceDivider} />
                    </div>
                    <div className={newCss.actionsSection}>
                      <NamedLink
                        className={newCss.editListingBtn}
                        name="EditListingPage"
                        params={{
                          slug: createSlug(listing.attributes.title || ''),
                          id: listing.id.uuid,
                          type: listing.attributes.state === 'draft' ? 'draft' : 'edit',
                          tab: 'details',
                        }}
                      >
                        <FormattedMessage id="ListingPage.editListing" />
                      </NamedLink>
                      <ShareButton
                        listing={listing}
                        className={newCss.shareListingBtn}
                        shareLSHLink={true}
                        buttonText={intl.formatMessage({ id: 'ListingPage.shareListing' })}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <ProductOrderForm
                formId="OrderPanelProductOrderForm"
                currentStock={currentStock}
                allowOrdersOfMultipleItems={allowOrdersOfMultipleItems}
                pickupEnabled={pickupEnabled && displayPickup}
                shippingEnabled={shippingEnabled && displayShipping}
                displayDeliveryMethod={displayPickup || displayShipping}
                onContactUser={onContactUser}
                shippingType={shippingType}
                pageType={pageType}
                handelCart={handelCart}
                isCart={isCart}
                enableMulticart={enableMulticart}
                userSelectedStockQuantity={selectedStock}
                productPrice={
                  <PriceMaybe
                    price={price}
                    publicData={publicData}
                    validListingTypes={validListingTypes}
                    intl={intl}
                    marketplaceCurrency={marketplaceCurrency}
                    showCurrencyMismatch
                  />
                }
                currentUserCartCount={currentUserCartCount}
                {...sharedProps}
              />
            )}
          </div>
        )}

        <div className={newCss.mobileBtnBox}>
          {isOwnListing ? (
            <div className={newCss.stickyBottomBar}>
              <div className={newCss.stickyBottomBarWrapper}>
                <div className={newCss.stickyBottomBarInner}>
                  <div className={newCss.priceSection}>
                    <div className={newCss.productPriceWrapper}>
                      <PriceMaybe
                        price={price}
                        publicData={publicData}
                        validListingTypes={validListingTypes}
                        intl={intl}
                        marketplaceCurrency={marketplaceCurrency}
                        showCurrencyMismatch
                      />
                    </div>
                    <div className={newCss.priceDivider} />
                  </div>
                  <div className={newCss.actionsSection}>
                    <NamedLink
                      className={newCss.editListingBtn}
                      name="EditListingPage"
                      params={{
                        slug: createSlug(listing.attributes.title || ''),
                        id: listing.id.uuid,
                        type: listing.attributes.state === 'draft' ? 'draft' : 'edit',
                        tab: 'details',
                      }}
                    >
                      <FormattedMessage id="ListingPage.editListing" />
                    </NamedLink>
                    <ShareButton
                      listing={listing}
                      className={newCss.shareListingBtn}
                      shareLSHLink={true}
                      buttonText={intl.formatMessage({ id: 'ListingPage.shareListing' })}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <ProductOrderForm
              formId="OrderPanelProductOrderForm"
              currentStock={currentStock}
              allowOrdersOfMultipleItems={allowOrdersOfMultipleItems}
              pickupEnabled={pickupEnabled && displayPickup}
              shippingEnabled={shippingEnabled && displayShipping}
              displayDeliveryMethod={displayPickup || displayShipping}
              onContactUser={onContactUser}
              shippingType={shippingType}
              pageType={pageType}
              handelCart={handelCart}
              isCart={isCart}
              enableMulticart={enableMulticart}
              userSelectedStockQuantity={selectedStock}
              productPrice={
                <PriceMaybe
                  price={price}
                  publicData={publicData}
                  validListingTypes={validListingTypes}
                  intl={intl}
                  marketplaceCurrency={marketplaceCurrency}
                  showCurrencyMismatch
                />
              }
              currentUserCartCount={currentUserCartCount}
              {...sharedProps}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomOrderPannel;
